export default {
  /*
   * index() lista las paradas
   */
  index(params) {
    return Vue.http.get('topology/stops', {params}).then(response => response.data.data)
  },

  selectable(municipalityId, query = '') {
    const params = {
      municipality_id: municipalityId,
      per: 0,
      template: 'complete'
    }

    if (query) params.full_name_normalized = query

    return Vue.http.get('topology/stops', {
      params,
      skipLoading: true,
      skipError: true
    }).then(response => response.data.data)
  },
  /*
   * favorites() lista los paraderos favoritos del usuario
   */
  favorites(params) {
    return Vue.http.get(
      'topology/stops/client_favorites', params
    ).then(response => response.data.data)
  },
  /*
   * nearests() lista los paraderos cercanos a la posicion y radio de los parámetros
   */
  nearests(params, skipLoading = null) {
    return Vue.http.get(
      'topology/stops/nearests', {params, skipLoading}
    ).then(response => response.data)
  },

  /*
   * nearests() lista los paraderos de bicicletas cercanos a la posicion
   */
  bikes(id) {
    return Vue.http.get(
      `nearest_stops/bikes?id=${id}`
    ).then(response => response.data)
  }
}
